import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from "vue";
import { currency, normalizeCurrency } from "@/helpers/filters";
import { CurrencyInput } from "vue-currency-input";
import { useI18n } from "vue-i18n-composable";
import { BFormGroup, BFormRadioGroup, BFormSelect, BRow, BCol } from "bootstrap-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AmountSelect',
  props: {
    minimumRequired: { default: 0 },
    actualCost: { default: 0 },
    actualCostLabel: { default: "components.user.add_credit_box.actual_cost_label_default" },
    addStandardOptions: { type: Boolean, default: false },
    label: { default: "components.user.add_credit_box.buttons.add_funds" },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    noCustomAmount: { type: Boolean, default: false },
    minimumDefault: { type: Boolean, default: false },
    value: null,
    maximum: { default: null }
  },
  emits: ["input"],
  setup(__props: any, { emit }) {

const props = __props as { minimumRequired: number, actualCost: number, actualCostLabel: string, addStandardOptions: boolean, label: string, loading: boolean, disabled: boolean, noCustomAmount: boolean, minimumDefault: boolean, value: number, maximum: number };

const { t: $t, n } = useI18n();





let customAmount = ref(
  props.maximum != null
    ? normalizeCurrency(props.maximum)
    : props.minimumRequired || props.minimumRequired > 0
    ? normalizeCurrency(props.minimumRequired)
    : 20
);

const purchasing = ref(false);
let selectedValue = ref(initialSelectedValue());

const amounts = computed(() => {
  const options = [];
  const balance = props.maximum;

  if (normalizedActualCost.value > 0 && (!balance || normalizedActualCost.value <= balance)) {
    options.push({
      text: $t("components.user.add_credit_box.options.trip", {
        label: props.actualCostLabel,
        amount: currency(normalizedActualCost.value),
      }),
      value: normalizedActualCost.value,
    });
  }

  if (props.addStandardOptions) {
    const standardOptions = [
      {
        text: n(10, "dollars_cad"),
        value: 10,
      },
      {
        text: n(20, "dollars_cad"),
        value: 20,
      },
      {
        text: n(50, "dollars_cad"),
        value: 50,
      },
      {
        text: n(100, "dollars_cad"),
        value: 100,
      },
    ];

    for (let i = 0, len = standardOptions.length; i < len; i += 1) {
      if (!balance || standardOptions[i].value <= balance) {
        options.push(standardOptions[i]);
      }
    }
  }
  if (!props.noCustomAmount) {
    options.push({
      text: $t("components.user.add_credit_box.amount.other"),
      value: "other",
    });
  }

  return options;
});

const normalizedMinimumRequired = computed(() => {
  return normalizeCurrency(props.minimumRequired);
});

const normalizedActualCost = computed(() => {
  return normalizeCurrency(props.actualCost);
});

function initialSelectedValue() {
  if (props.actualCost && !props.minimumDefault) {
    return normalizeCurrency(props.actualCost);
  }

  if (props.minimumRequired) {
    return normalizeCurrency(props.minimumRequired);
  }

  const validOptions = [10, 20, 50, 100];
  const balance = Number(props.maximum);

  if (props.maximum) {
    if (validOptions.includes(balance)) {
      return normalizeCurrency(balance);
    } else {
      return "other";
    }
  }

  if (props.addStandardOptions) {
    return 10;
  }

  return "other";
}

watch(
  () => props.minimumRequired,
  (newValue, oldValue) => {
    if (selectedValue.value === normalizeCurrency(oldValue)) {
      selectedValue.value = normalizeCurrency(newValue);
    }
    if (customAmount.value <= normalizeCurrency(oldValue)) {
      customAmount.value = normalizeCurrency(newValue);
    }
  }
);

watch(
  () => props.actualCost,
  (newValue, oldValue) => {
    if (selectedValue.value === normalizeCurrency(oldValue)) {
      selectedValue.value = normalizeCurrency(newValue);
    }
  }
);

watch(
  [selectedValue, customAmount],
  (newValue) => {
    const selected = newValue[0];
    const custom = newValue[1];
    emit("input", selected === "other" ? custom ?? 0 : selected);
  },
  { immediate: true }
);

return { __sfc: true,$t, n, props, emit, customAmount, purchasing, selectedValue, amounts, normalizedMinimumRequired, normalizedActualCost, initialSelectedValue, CurrencyInput, BFormGroup, BFormRadioGroup, BFormSelect, BRow, BCol }
}

})